// src/store/authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { TokenUserPayloadSerializer } from "@/types/member"
import { AcupointConstants } from "@core/constants/AcupointConstants"

// 초기 상태 타입 정의
interface UserPayload {
  token: string | null
  member: TokenUserPayloadSerializer | null
}

const initialState: UserPayload = {
  token: null,
  member: null,
}

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    sessionLoginSuccess: (state, action: PayloadAction<TokenUserPayloadSerializer>) => {
      state.token = null
      state.member = action.payload
    },
    // 로그아웃 시 토큰과 payload 초기화
    logout: state => {
      state.token = null
      state.member = null
      // 경혈 데이터도 초기화
      AcupointConstants.clearServerData()
    },
  },
})

export const { sessionLoginSuccess, logout } = memberSlice.actions

export default memberSlice.reducer

